import React from 'react';
import { X } from 'lucide-react';
import { PalletSummaryDto } from '../../../../../types/picking';
import { PickingLine } from '../types';
import { NumericInput } from '../../../../common/inputs';

interface SplitModalProps {
  isOpen: boolean;
  line: PickingLine | null;
  pallets: PalletSummaryDto[];
  splitQuantities: {[palletId: string]: number};
  onQuantityChange: (palletId: string, quantity: number) => void;
  onConfirm: () => void;
  onClose: () => void;
}

export const SplitModal: React.FC<SplitModalProps> = ({
  isOpen,
  line,
  pallets,
  splitQuantities,
  onQuantityChange,
  onConfirm,
  onClose
}) => {
  if (!isOpen || !line) return null;

  const totalAssigned = Object.values(splitQuantities).reduce((sum, qty) => sum + qty, 0);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-0 sm:p-4">
      <div className="bg-white w-full h-full sm:h-auto sm:rounded-lg sm:max-w-lg overflow-y-auto">
        <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200 sticky top-0 bg-white z-10">
          <h3 className="text-lg font-semibold">Split linje til paller</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 min-h-[44px] min-w-[44px] flex items-center justify-center"
          >
            <X size={24} />
          </button>
        </div>


        <div className="p-4 sm:p-6">
        <p className="text-sm text-gray-600 mb-4">
          Vare: {line.itemNo} - {line.itemDescription}<br/>
          Totalt antall: {line.qty} | Tildelt: {totalAssigned} | Gjenstår: {line.qty - totalAssigned}
        </p>

        <div className="space-y-3 mb-6">
          {pallets.map(pallet => (
            <div key={pallet.sscc} className="flex items-center gap-3 p-3 border rounded-lg">
              <div className="flex-1">
                <span className="font-medium">Pall {pallet.sscc}</span>
                <p className="text-xs text-gray-500">
                  {pallet.totalItems} varer, {pallet.totalQuantity} stk
                </p>
              </div>
              <NumericInput
                mode="integer"
                min="0"
                max={line.qty}
                placeholder="Antall"
                className="w-24 sm:w-20 p-2 min-h-[44px] border border-gray-300 rounded text-center"
                value={splitQuantities[pallet.sscc] || ''}
                onChange={(e) => onQuantityChange(pallet.sscc, parseInt(e.target.value) || 0)}
              />
            </div>
          ))}
        </div>


        <div className="flex flex-col sm:flex-row gap-3 sticky bottom-0 bg-white pt-4 pb-2 sm:pb-0">
          <button
            onClick={onConfirm}
            className="flex-1 bg-blue-600 text-white py-3 sm:py-2 min-h-[44px] rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed order-1"
            disabled={totalAssigned === 0}
          >
            Bekreft split
          </button>
          <button
            onClick={onClose}
            className="px-4 py-3 sm:py-2 min-h-[44px] border border-gray-300 rounded-lg hover:bg-gray-50 order-2"
          >
            Avbryt
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};